import { observable } from 'mobx';

import createCoverageDetailsPageVM from '../pages/createCoverageDetailsPageVM';
import createPersonalDetailsPageVM from '../pages/createPersonalDetailsPageVM';
import createConfirmationPageVM from '../pages/createConfirmationPageVM';
import PAGES from '../definitions/Pages';
import PROVIDER_IDS from '../definitions/ProviderIds';


function createViewStore(context) {
    if (!context) {
        throw new TypeError('"context" object shouldn\'t  be empty', 'createViewStore.js');
    }

    const viewStore = observable({
        context,

        coverageDetails: createCoverageDetailsPageVM(context),
        personalDetails: createPersonalDetailsPageVM(context),
        confirmation: createConfirmationPageVM(context),

        activePage: null,

        get activePageName() {
            return viewStore.activePage.name;
        },
        get isJourneyComplete() {
            return viewStore.coverageDetails.isCompleted
                && viewStore.personalDetails.isCompleted;
        },
        get isJointPolicy() {
            return context.journey?.isJointPolicy;
        },

        get shouldShowPhoneNumber() {
            if (viewStore.activePageName === PAGES.CONFIRMATION.id) {
                return viewStore.context.provider?.id === PROVIDER_IDS.PRIMARY_PROVIDER;
            } else {
                return true;
            }
        },

        showCoverageDetailsPage() {
            viewStore.activePage = viewStore.coverageDetails;
        },
        showPersonalDetailsPage() {
            viewStore.activePage = viewStore.personalDetails;
        },
        showConfirmationPage() {
            viewStore.activePage = viewStore.confirmation;
        },
    });

    // @todo : Add in resume logic here if we are doing metadata resuming
    viewStore.showCoverageDetailsPage();

    return viewStore;
}


export default createViewStore;